<div class="filter full-span">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!jewel.show" (click)="toggleShowJewel()"></button>
  </span>
  <span class="filter-body" [class.equipment-filter-from-preset]="jewel.fromProgressPreset || jewel.fromClassPreset">
    <app-autocomplete
      [allowAll]="false"
      [options]="jewelTypes"
      [disabled]="!jewel.show"
      [showOptions]="true"
      [selectedValues]="jewel.jewelType"
      (selectedValuesChange)="jewelTypeChanged($event);"></app-autocomplete>
    <span class="sep"></span>
    <app-select-rarity [greaterThanOrEqualTo]="true" [includeNormal]="false" [includeUnique]="false" [disabled]="!jewel.show" [(ngModel)]="jewel.rarity" (selectedValueChange)="minRarityChanged($event);"></app-select-rarity>
    <span class="sep"></span>
    <input type="number" placeholder="≥ iLvl" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" style="min-width: 55px;"
      [disabled]="!jewel.show"
      [(ngModel)]="jewel.itemLevel" (change)="updateFilter()">
    @if (poe1) {
      <span class="sep"></span>
      <span class="input-group-btn">
        <button class="btn toggle-button customize-btn" [class.no-conditions]="hasAdvancedConditions === 0" [class.active]="advancedConditionsOpen" [class.disabled]="!jewel.show"
          (click)="toggleAdvancedOptionsOpen()">
          <span class="icon icon-cog"></span>
          <span class="label">{{ hasAdvancedConditions }}</span>
        </button>
      </span>
    }
    <span class="sep"></span>

    <span class="input-group-btn">
      <app-tooltip-wrapper [right]="true">
        <button class="btn toggle-button customize-btn" [class.no-conditions]="hasHighlightConfig === 0" [class.active]="highlightConfigOpen" [class.disabled]="!jewel.show"
          (click)="toggleHighlightConfigOpen()">
          <span class="icon icon-equalizer"></span>
          <span class="label">{{ hasHighlightConfig }}</span>
        </button>
        <ng-template #tooltip>Configure Highlights</ng-template>
      </app-tooltip-wrapper>
    </span>

    <span class="sep"></span>
    <span class="input-group-btn">
      <button class="btn remove-btn" (click)="removeJewelType()"></button>
    </span>
  </span>
</div>
@if (poe1 && advancedConditionsOpen) {
  <app-advanced-equipment-conditions
    [isArmour]="false"
    [advancedConditions]="jewel"
    [isActive]="jewel.show"
    (updateFilterEmitter)="hasAdvancedConditions = getNumberOfAdvancedConditions(); updateFilter()"></app-advanced-equipment-conditions>
  <div class="clear"></div>
}

@if (navigationEnabled || highlightConfigOpen) {
  <div [class.collapsed]="!highlightConfigOpen">
    <app-my-equipment-highlights
      [equipment]="jewel"
      [jewel]="jewel"
      [equipmentType]="'jewel'"
      [equipmentIndex]="index"
      (updateFilterEmitter)="hasHighlightConfig = getNumberOfHighlightConfig(); updateFilter()"></app-my-equipment-highlights>
    <div class="clear"></div>
  </div>
}
